<div class="row">
  <div class="col-sm-12">
    <h2>Color Pallette</h2>
  </div>

  @for (chunk of chunks; track chunk) {
    <div class="col-sm-3">
      @for (color of chunk; track color) {
        <div class="pallette_chunk" [style.background-color]="color.value">
          {{color.key}}
        </div>
      }
    </div>
  }
  <div class="col-sm-12">
    <hr />
  </div>
</div>
